(function (window, $, Argument, app) {
    var Math = window.Math;
    var parseInt = window.parseInt;
    
    function Scroll() {
        var _this = this;
        
        this.to = function (id) {
            var $to = $('#' + id);
            
            if ($to.length === 0) {
                return;
            }
            
            var top = $to.offset().top;
            var margin = parseInt($to.css('margin-top'));
            
            var scrollTo = Math.ceil(top - margin) - $('#main-nav').outerHeight();
            var maxScrollPos = app.$doc.height() - $(window).height();
            
            scrollTo = Math.min(scrollTo, maxScrollPos);
            
            var distance = window.Math.abs($(window).scrollTop() - scrollTo);
            var speed = 800 / 1000; // in px/ms
            var duration = Math.min(distance / speed, 1500);
            
            $("html, body").animate({scrollTop: scrollTo}, duration, "easeInOutSine");
            
            return false;
        };
    }
    
    app.Scroll = new Scroll();
})(window, jQuery, Argument, MedwaySchools);
